(() => {
  'use strict';

  const config = window.themeConfig || {};
  const rootUrl = config.routes.root || '';
  const cartUrl = config.routes.cart || '/cart';
  const cartAddUrl = config.routes.cartAdd || '/cart/add';
  const cartChangeUrl = config.routes.cartChange || '/cart/change.js';
  const moneyFormat = config.moneyFormat || '${{amount}}';

  const qs = (selector, scope = document) => scope.querySelector(selector);
  const qsa = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));

  const cartApiUrl = () => `${cartUrl.replace(/\/$/, '')}.js`;
  const cartAddApiUrl = () => `${cartAddUrl.replace(/\/$/, '')}.js`;
  const cartChangeApiUrl = () => `${cartChangeUrl.replace(/\/$/, '')}.js`;

  const isReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function escapeHTML(value) {
    const div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  function addCommas(value) {
    const parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  function formatMoney(cents, format = moneyFormat) {
    const numeric = Number(cents || 0) / 100;
    const value = numeric.toFixed(2);
    const noDecimals = String(Math.round(numeric));
    const amount = addCommas(value);
    const amountNoDecimals = addCommas(noDecimals);
    const commaSeparated = amount.replace(',', '.');
    const noDecimalsComma = amountNoDecimals.replace(',', '.');
    return format
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimalsComma)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, commaSeparated)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function showToast(message) {
    const toast = qs('[data-toast]');
    if (!toast) return;
    window.clearTimeout(toast._timer);
    toast.textContent = message;
    toast.classList.add('is-visible');
    toast._timer = window.setTimeout(() => {
      toast.classList.remove('is-visible');
    }, 2600);
  }

  function setCartCount(count) {
    qsa('[data-cart-count]').forEach((node) => {
      node.textContent = count;
    });
  }

  function closeDrawers() {
    qsa('[data-drawer-layer]').forEach((layer) => {
      layer.classList.remove('is-open');
      layer.setAttribute('aria-hidden', 'true');
    });
    qsa('[data-drawer-trigger]').forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
    });
  }

  function openDrawer(id) {
    qsa('[data-drawer-layer]').forEach((layer) => {
      const isTarget = layer.dataset.drawerLayer === id;
      layer.classList.toggle('is-open', isTarget);
      layer.setAttribute('aria-hidden', String(!isTarget));
    });
    qsa('[data-drawer-trigger]').forEach((button) => {
      button.setAttribute('aria-expanded', String(button.dataset.drawerTrigger === id));
    });
  }

  function updateCartCount(cart) {
    setCartCount(cart.item_count);
  }

  function quantityRowHtml(item) {
    return `
      <div class="cart-drawer__line-qty">
        <span class="cart-drawer__line-price">${formatMoney(item.line_price)}</span>
        <button class="cart-drawer__remove" type="button" data-cart-remove="${item.key}">Remove</button>
      </div>
    `;
  }

  function renderCartDrawer(cart) {
    const body = qs('[data-cart-drawer-body]');
    if (!body) return;
    updateCartCount(cart);

    if (cart.item_count === 0) {
      body.innerHTML = `
        <div class="cart-drawer__empty">
          <span class="cart-placeholder"><svg class="icon--large" width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="20" r="1.4"></circle><circle cx="17" cy="20" r="1.4"></circle><path d="M2.8 3.5h2.1l2.2 12.1h10.1l2.5-8.6H6.2"></path></svg></span>
          <h2>Your cart is empty</h2>
          <p>Add a little calm to your cleaning routine.</p>
          <a class="btn btn--primary" href="${escapeHTML(rootUrl)}collections/all">Shop All</a>
        </div>
      `;
      return;
    }

    const lines = cart.items.map((item) => {
      const image = item.image
        ? `<img src="${escapeHTML(item.image)}" alt="${escapeHTML(item.product_title)}" width="82" height="82" loading="lazy">`
        : `<span class="cart-drawer__image-empty"><svg aria-hidden="true" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 3 4 7.5v9L12 21l8-4.5v-9L12 3Z"></path></svg></span>`;
      const variant = item.variant_title ? `<p class="cart-drawer__line-variant">${escapeHTML(item.variant_title)}</p>` : '';
      return `
        <div class="cart-drawer__line" data-cart-line-key="${item.key}">
          <a href="${escapeHTML(item.url)}">${image}</a>
          <div>
            <a class="cart-drawer__line-title" href="${escapeHTML(item.url)}">${escapeHTML(item.product_title)}</a>
            ${variant}
            <p class="cart-drawer__line-price">${formatMoney(item.final_line_price || item.line_price)}</p>
          </div>
          ${quantityRowHtml(item)}
        </div>
      `;
    }).join('');

    body.innerHTML = `
      <div class="cart-drawer__items">
        ${lines}
      </div>
      <div class="cart-drawer__footer">
        <div class="cart-drawer__subtotal-row">
          <span>Subtotal</span>
          <strong>${formatMoney(cart.total_price)}</strong>
        </div>
        <a class="btn btn--primary btn--block" href="${escapeHTML(cartUrl)}">View Cart</a>
        <button class="btn btn--outline btn--block cart-drawer__checkout" type="button" style="margin-top:.7rem">Checkout</button>
      </div>
    `;

    qsa('[data-cart-remove]', body).forEach((button) => {
      button.addEventListener('click', async () => {
        const form = new FormData();
        form.append('id', button.dataset.cartRemove);
        form.append('quantity', '0');
        await changeCart(form);
      });
    });
  }

  async function refreshCart() {
    const response = await fetch(cartApiUrl(), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!response.ok) throw new Error('Cart refresh failed');
    const cart = await response.json();
    renderCartDrawer(cart);
    return cart;
  }

  async function changeCart(formData) {
    try {
      await fetch(cartChangeApiUrl(), {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      await refreshCart();
    } catch (error) {
      showToast('Could not update the cart. Please try again.');
    }
  }

  async function addToCart(form) {
    const submit = form.querySelector('button[type="submit"]');
    const originalText = submit ? submit.textContent : '';
    if (submit) {
      submit.disabled = true;
      submit.textContent = 'Adding...';
    }

    try {
      const response = await fetch(cartAddApiUrl(), {
        method: 'POST',
        body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) {
        throw new Error('Add failed');
      }
      await refreshCart();
      openDrawer('cart');
      showToast('Added to your cart');
    } catch (error) {
      showToast('This item is not available. Please choose another option.');
    } finally {
      if (submit) {
        submit.disabled = false;
        submit.textContent = originalText;
      }
    }
  }

  function initDrawers() {
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-drawer-trigger]');
      if (trigger) {
        event.preventDefault();
        const id = trigger.dataset.drawerTrigger;
        const layer = qs(`[data-drawer-layer="${id}"]`);
        if (layer && layer.classList.contains('is-open')) {
          closeDrawers();
        } else {
          openDrawer(id);
        }
        return;
      }

      const cartTrigger = event.target.closest('[data-drawer-trigger-cart]');
      if (cartTrigger) {
        event.preventDefault();
        refreshCart().then(() => openDrawer('cart')).catch(() => {
          window.location.href = cartTrigger.href;
        });
        return;
      }

      const closeTrigger = event.target.closest('[data-drawer-close]');
      if (closeTrigger) {
        closeDrawers();
        return;
      }

      const checkoutButton = event.target.closest('.cart-drawer__checkout');
      if (checkoutButton) {
        const form = document.createElement('form');
        form.method = 'post';
        form.action = cartUrl;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'checkout';
        form.appendChild(input);
        document.body.appendChild(form);
        form.submit();
        return;
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeDrawers();
      }
    });
  }

  function initAddToCart() {
    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-add-to-cart]');
      if (!form) return;
      event.preventDefault();
      addToCart(form);
    });
  }

  function initProductOptions() {
    const jsonNode = qs('[data-product-json]');
    const form = qs('[data-product-form]');
    if (!jsonNode || !form) return;

    let productData = null;
    try {
      productData = JSON.parse(jsonNode.textContent);
    } catch (error) {
      return;
    }

    const selects = qsa('[data-option-select]', form);
    const variantId = qs('[data-variant-id]', form);
    const submit = qs('[data-product-submit]', form);
    const priceNode = qs('[data-product-price]');

    function findVariant() {
      const values = selects.map((select) => select.value);
      const matches = (productData.variants || []).filter((variant) =>
        variant.options.every((option, index) => option === values[index])
      );
      const available = matches.find((variant) => variant.available);
      return available || matches[0] || null;
    }

    function updateProduct() {
      const variant = findVariant();
      if (!variant) return;
      variantId.value = variant.id;
      if (submit) {
        submit.disabled = !variant.available;
        submit.querySelector('span').textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
      if (priceNode) {
        priceNode.textContent = formatMoney(variant.price);
      }
    }

    selects.forEach((select) => {
      select.addEventListener('change', updateProduct);
    });
    updateProduct();
  }

  function initQuantity() {
    document.addEventListener('click', (event) => {
      const minus = event.target.closest('[data-quantity-minus]');
      const plus = event.target.closest('[data-quantity-plus]');
      if (!minus && !plus) return;
      const group = (minus || plus).closest('[data-quantity]');
      if (!group) return;
      const input = qs('[data-quantity-input]', group);
      if (!input) return;
      const current = parseInt(input.value, 10) || 1;
      input.value = minus ? Math.max(1, current - 1) : current + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function initGallery() {
    document.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-product-thumb]');
      if (!thumb) return;
      const image = qs('[data-product-media]');
      if (image) {
        image.src = thumb.dataset.src;
        image.alt = thumb.dataset.alt || '';
      }
      qsa('[data-product-thumb]').forEach((node) => {
        node.classList.toggle('is-active', node === thumb);
      });
    });
  }

  function initSort() {
    document.addEventListener('change', (event) => {
      const select = event.target.closest('[data-sort-select]');
      if (!select) return;
      const form = select.closest('form');
      if (form) form.submit();
    });
  }

  function initReveal() {
    document.documentElement.classList.add('js');
    const items = qsa('[data-reveal]');
    if (!items.length || isReducedMotion) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    items.forEach((item) => observer.observe(item));
  }

  async function initCart() {
    try {
      await refreshCart();
    } catch (error) {
      qsa('[data-cart-count]').forEach((node) => {
        node.textContent = '0';
      });
    }
  }

  initDrawers();
  initAddToCart();
  initProductOptions();
  initQuantity();
  initGallery();
  initSort();
  initReveal();
  initCart();
})();
